import React from 'react'

const TransactionTable = () => {
  return (
    <div>TransactionTable</div>
  )
}

export default TransactionTable